import React from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import Switches from '../../../../../components/fields/Switches/Switches';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';
import { infoFormatterIntl } from '../../../../../utils/formatters';
import FileView from '../../../../../components/fields/FileInput/FileView';

export default function AddressView(props) {
  const {
    fieldsValidation = {},
    procedure,
    applicantType,
    currentApplication = {},
  } = props;

  const applicant_new = currentApplication?.applicant_new || {};
  const files = currentApplication?.files || [];
  const registry_subject = currentApplication?.registry_subject || {};

  const {
    address: oldAddress,
    office_address: oldOfficeAddress,
  } = registry_subject;

  const { address, office_address } = applicant_new;
  const address_change_document = files.find(item => item.collection_name === 'address_change_document');

  const isValidProcedure = [PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_8, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure);
  const isValidApplicantType = [USER_TYPE.PRIVATE_PERSON_OLD, USER_TYPE.PRIVATE_PERSON, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(applicantType);

  if (!isValidProcedure || !isValidApplicantType) {
    return null;
  }

  return (
    <>
      <div className="f4 mt-3">Изменился адрес регистрации и/или проживания</div>

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: !!address || address === null,
            }}
            label="Изменился адрес регистрации"
          />
        </Col>
      </Row>
      {(!!address || address === null) && (
      <>
        <Row className="row-cols-1">
          {infoFormatterIntl('old.address_registration', oldAddress, fieldsValidation, 'address')}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('new.address_registration', address, fieldsValidation, 'applicant_new.address')}
        </Row>
      </>
      )}

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: !!address || address === null,
            }}
            label="Изменился адрес проживания"
          />
        </Col>
      </Row>
      {(!!address || address === null) && (
        <>

          <Row className="row-cols-1">
            {infoFormatterIntl('old.address', oldOfficeAddress, fieldsValidation, 'address')}
          </Row>
          <Row className="row-cols-1">
            {infoFormatterIntl('new.address', office_address, fieldsValidation, 'applicant_new.address')}
          </Row>

          <Row className="row-cols-1">
            {infoFormatterIntl(
              'media.address_change_document',
              address_change_document ? (
                <FileView
                  readOnly
                  withoutMime
                  withoutHr
                  files={[address_change_document]}
                />
              ) : null,
              fieldsValidation,
              '',
              6,
            )}
          </Row>
        </>
      )}

      <div className="hr-row mt-3" />
    </>
  );
}
